import { forwardRef } from "react";

export const DigitalCard = forwardRef(({ realtor, links, programName }, ref) => {
  const initials = `${(realtor.first_name || "")[0] || ""}${(realtor.last_name || "")[0] || ""}`.toUpperCase();
  const shortUrl = (links?.client_url || "").replace(/^https?:\/\//, "");
  return (
    <div
      ref={ref}
      data-testid="digital-client-card"
      style={{ width: 640, height: 800 }}
      className="relative bg-[#0B0B0B] text-white overflow-hidden shrink-0"
    >
      <div className="absolute inset-5 border border-[#c19a6b]/45" />
      <div className="relative h-full flex flex-col items-center text-center px-14 py-16">
        <p className="font-display text-[22px] tracking-[0.42em] text-white">ARK</p>
        <p className="text-[9px] tracking-[0.4em] text-white/45 mt-1.5">FURNITURE REVIVAL</p>

        <div className="w-10 h-[1px] bg-[#c19a6b] mt-10" />

        <p className="text-[10px] tracking-[0.34em] text-[#c19a6b] mt-10">A PRIVATE CLIENT BENEFIT</p>

        {realtor.headshot_url ? (
          <img
            src={realtor.headshot_url}
            alt={realtor.display_name}
            crossOrigin="anonymous"
            className="w-[86px] h-[86px] object-cover rounded-full mt-7 ring-1 ring-[#c19a6b]/60"
          />
        ) : (
          <div className="w-[86px] h-[86px] rounded-full mt-7 border border-[#c19a6b]/60 flex items-center justify-center">
            <span className="font-display text-2xl text-[#c19a6b]">{initials || "ARK"}</span>
          </div>
        )}

        <h2 className="font-display text-[40px] leading-tight mt-6">{realtor.display_name}</h2>
        {realtor.brokerage && (
          <p className="text-[10px] tracking-[0.28em] text-white/50 mt-2 uppercase">{realtor.brokerage}</p>
        )}

        <div className="mt-9">
          <p className="font-display text-[26px] text-[#c19a6b] leading-snug">Signature Revival</p>
          <p className="text-[13px] text-white/65 mt-1.5 tracking-wide">at our Essential Revival rate</p>
        </div>

        <div className="flex items-center gap-3 mt-9 text-[9px] tracking-[0.22em] text-white/55">
          <span>OLD HOME</span>
          <span className="text-[#c19a6b]">→</span>
          <span>ARK WORKSHOP</span>
          <span className="text-[#c19a6b]">→</span>
          <span>NEW HOME</span>
        </div>

        <div className="mt-auto flex items-end gap-5 w-full">
          <div className="bg-white p-2">
            <img
              src={`${links?.qr_image_url}?size=6`}
              alt="Scan for your private client benefit"
              crossOrigin="anonymous"
              className="w-[104px] h-[104px] block"
            />
          </div>
          <div className="text-left pb-1">
            <p className="text-[9px] tracking-[0.3em] text-[#c19a6b]">SCAN TO CLAIM</p>
            <p className="text-[11px] text-white/70 mt-2 leading-relaxed break-all">{shortUrl}</p>
            <p className="text-[9px] tracking-[0.2em] text-white/35 mt-2 uppercase">{programName}</p>
          </div>
        </div>
      </div>
    </div>
  );
});

DigitalCard.displayName = "DigitalCard";
